import { IconButton, Tooltip, withStyles } from '@material-ui/core';
import type { IconButtonProps } from '@material-ui/core';
import type React from 'react';

export interface IProps extends IconButtonProps, React.PropsWithChildren {
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
  tooltip?: string;

  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => any;
}

const IconButtonCustomPadding = withStyles({
  root: {
    padding: '4px 12px'
  }
})(IconButton);

const MenuIconButton: React.FC<IProps> = (props) => {
  const {
    children,
    iconClassName,
    iconStyle,
    tooltip,
    // strip unused
    action = null,
    ...other
  } = props;
  const content = iconClassName ? <i className={iconClassName} style={iconStyle} /> : children;
  const iconButton = <IconButtonCustomPadding {...other}>{content}</IconButtonCustomPadding>;

  if (tooltip) {
    return (
      <Tooltip title={tooltip} aria-label={tooltip}>
        {iconButton}
      </Tooltip>
    );
  }
  return iconButton;
};

export default MenuIconButton;
